import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import FormatPrice from '~/components/Atoms/FormatPrice.vue';
import { useCustomerGroup } from '~/composables/useCustomerGroup';
import { useGetTranslations } from '~/composables/useGetTranslations';
import PriceDiscountLabel from '~/components/Product/ProductPrice/PriceDiscountLabel.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceDisplay',
  props: {
    isGift: {
      type: Boolean,
      default: false
    },
    specialPrice: {
      type: Number,
      default: undefined
    },
    regularPrice: {
      type: Number,
      default: 0
    },
    price: {
      type: Object,
      default: function _default() {
        return {
          regular: 0
        };
      }
    },
    capacity: {
      type: [String, Number],
      default: ''
    },
    isPriceDiscountLabel: {
      type: Boolean,
      default: false
    },
    isLayoutReverse: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useCustomerGroup = useCustomerGroup(),
      isCustomerGroupWithoutVat = _useCustomerGroup.isCustomerGroupWithoutVat;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var isDiscounted = computed(function () {
      return props.specialPrice !== props.regularPrice;
    });
    return {
      __sfc: true,
      props: props,
      isCustomerGroupWithoutVat: isCustomerGroupWithoutVat,
      translate: translate,
      isDiscounted: isDiscounted,
      FormatPrice: FormatPrice,
      PriceDiscountLabel: PriceDiscountLabel
    };
  }
});